import * as React from "react";
import {FUNDING, PayPalScriptProvider} from "@paypal/react-paypal-js";
import {PayPalScriptOptions} from "@paypal/paypal-js";
import {PropsWithChildren} from "react";
import {clientId} from "../../Banner/PayPalPayLaterMessage";
import {getPayPalLocale, isPayLaterAllowed} from "./helpers/paypalHelperFunctions";

const locale = getPayPalLocale();
const buyerCountry = locale?.split("_")[1];

const options: PayPalScriptOptions = {
  clientId,
  components: "buttons",
  currency: window.c_ActiveCurrency,
  disableFunding: [FUNDING.CARD, FUNDING.GIROPAY, FUNDING.SEPA, FUNDING.SOFORT],
  enableFunding: isPayLaterAllowed() ? FUNDING.PAYLATER : undefined,
  locale,
  buyerCountry,
  intent: "authorize",
  commit: false /* https://developer.paypal.com/sdk/js/configuration/#link-commit, Will be toggled in the `BraintreeButtonLoader.tsx` */,
  vault: false,
  dataNamespace: "main",
};

const PayPalContextProvider: React.FC<PropsWithChildren> = ({children}) => {
  return <PayPalScriptProvider options={options}>{children}</PayPalScriptProvider>;
};

export default PayPalContextProvider;
